export default {
    empresas: [],
    attachments: [],
    filter: {
        company_id: null,
        product_id: null,
        page: 1,
        per_page: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    cargando_datos_select: false,
}



